import Form      from "@/utils/forms/form";
import FileField from "@/utils/forms/fields/fileField";

class UserFileValidator extends Form {
    constructor(data, file) {
        super(data);
        this[file.name] = new FileField({
            label: "Фото документа",
            maxFileSize: 1024 * 5,
            allowedExtensions: ["jpeg", "jpg"]
        });
    }
}

export default class UserFilesForm {
    constructor(pages) {
        this.files = [];
        this._pages = this.sorted(pages);
        this._filesCount = pages.length;
    }

    sorted(pages) {
        return pages.sort((a, b) => {
            if (a.page < b.page) {
                return -1
            }
            if (a.page > b.page) {
                return 1
            }
            return 0
        })
    }

    get nextIndex() {
        let i = 0;
        while (i < this.files.length) {
            if (!this.files[i]) {
                break
            }
            i++;
        }
        return i
    }

    setFile(file) {
        const data = {};
        data[file.name] = file;
        const errors = new UserFileValidator(data, file).errors;
        if (this._isValid(errors)) {
            const index = this.nextIndex;
            this.files.splice(index, 1, {
                page: this._pages[index].page,
                needRecognition: this._pages[index]["need_recog"],
                file: file,
                filename: file.name,
            });
            return null;
        }
        return errors;
    }

    removeAt(index) {
        this.files.splice(index, 1, null);
    }

    _isValid(errors) {
        return Object.keys(errors).length === 0;
    }

    get totalAttached() {
        return this.files.reduce((a, b) => {
            return a + (b ? 1 : 0)
        }, 0);
    }

    get allSelected() {
        return this.totalAttached === this._filesCount;
    }

    serialize() {
        return new Promise((resolve, reject) => {
            const self = this;
            let totalResolved = 0;

            this.files.forEach((val, i) => {
                const reader = new FileReader();
                reader.onload = () => {
                    self.files[i]["file"] = reader.result.replace(/data:\w*\/\w*;base64,/, "");
                    totalResolved++;
                };
                reader.onerror = () => {
                    reader.abort();
                    reject(new DOMException("Problem parsing input file."));
                };
                reader.readAsDataURL(val["file"]);
            });
            const interval = setInterval(() => {
                if (totalResolved === self.files.length) {
                    clearInterval(interval);
                    resolve(self.files);
                }
            }, 200);
        });
    }

    reset() {
        this.files = []
    }

}